/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */
import * as TurboModuleRegistry from '../TurboModule/TurboModuleRegistry';
export default TurboModuleRegistry.get('NativeAnimatedModule');